var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 3.375C13.9518 3.375 3.375 13.9518 3.375 27C3.375 40.0482 13.9518 50.625 27 50.625C40.0482 50.625 50.625 40.0482 50.625 27C50.625 13.9518 40.0482 3.375 27 3.375Z",
    fill: "url(#paint0_linear_13522_18252)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3423 34.1597C37.7822 34.5995 37.7822 35.3117 37.3423 35.7504L35.7504 37.3423C35.3105 37.7822 34.5984 37.7822 34.1597 37.3423L27.0002 30.1817L19.8407 37.3423C19.4008 37.7822 18.6887 37.7822 18.2499 37.3423L16.658 35.7504C16.2182 35.3105 16.2182 34.5984 16.658 34.1597L23.8187 27.0002L16.658 19.8407C16.2182 19.4008 16.2182 18.6887 16.658 18.2499L18.2499 16.658C18.6898 16.2182 19.4019 16.2182 19.8407 16.658L27.0002 23.8187L34.1597 16.658C34.5995 16.2182 35.3117 16.2182 35.7504 16.658L37.3423 18.2499C37.7822 18.6898 37.7822 19.4019 37.3423 19.8407L30.1817 27.0002L37.3423 34.1597Z",
    fill: "url(#paint1_linear_13522_18252)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13522_18252",
    x1: 27,
    y1: 3.375,
    x2: 27,
    y2: 50.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13522_18252",
    x1: 27.0002,
    y1: 16.3282,
    x2: 27.0002,
    y2: 37.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF666D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0211F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFRemove);
export default __webpack_public_path__ + "static/media/f-remove.c96863576d3f485dca0af13de1f56727.svg";
export { ForwardRef as ReactComponent };